<template>
  <div class="m-detail">
    <div
      class="m-infos"
      @click="handleList"
    >
      <avatar :src="userInfo.avatar" />
      <div>
        <div>
          <span class="m-infos-name">{{ userInfo.name }}</span>
          <span class="m-infos-posi">{{ userInfo.position }}</span>
        </div>
        <div class="m-infos-dep">
          {{ userInfo.department }}
        </div>
      </div>
    </div>
    <a-tabs @change="changeKrResult">
      <a-tab-pane
        v-for="(i,n) in objectDataList"
        :key="n+1"
        :tab="`目标${n+1}`"
      >
        <div class="m-o-box">
          <span class="m-o-weight">
            目标权重={{ i.objectWeight }}%
          </span>
          <div class="m-o-content">
            {{ i.objectDetail }}
          </div>
        </div>
        <div
          v-for="(v,f) in currentObject"
          :key="f"
          class="m-kr-outer"
        >
          <div class="m-kr-box1">
            <span class="m-kr-weight">
              权重={{ v.krWeight }}%
            </span>
            <div class="m-kr-content">
              {{ v.krDetail }}
            </div>
          </div>
          <div class="m-kr-box2">
            <div class="m-kr-tag1">
              {{ v.sevenTarget }}
            </div>
            <div class="m-kr-tag2">
              {{ v.tenTarget }}
            </div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { setDDTitle } from '@utils'

import { Tabs, message } from 'ant-design-vue'
import Avatar from '@components/avatar/index.vue'

Vue.use(Tabs)

export default {
  name: 'OKRDetail',
  components: {
    Avatar,
  },
  props: {},
  data() {
    return {
      userInfo: {
        name: '',
        position: '',
        department: '',
        avatar: '',
      },
      year: '',
      quarter: '',
      userId: '',
      okrId: '',
      objectDataList: [],
      currentObject: {},
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.userId,
    }),
  },
  beforeCreate() {
    // 因默认title为“校宝 OKR”，先清空标题，获取数据后再拼接标题
    setDDTitle('')
  },

  async created() {
    this.okrId = this.$route.params.okrId

    this.$store.dispatch('getServerTime')
    try {
      await this.fetchOkrDetail()
      document.title = `${this.year}年Q${this.quarter}季度业绩目标`
    } catch (error) {
      const msg = error.errorMessage || error.message || '网络错误'
      message.error(msg)
    }
    setDDTitle(`${this.year}年Q${this.quarter}季度业绩目标`)
  },
  methods: {
    /**
     * 获取 OKR 详情
     */
    async fetchOkrDetail() {
      const hide = message.loading('正在加载...')
      try {
        const {
          objectList,
          searchStaffInfo,
          year,
          quarter,
          userId,
        } = await this.$api.okr.getDetail({
          id: this.okrId,
        })
        this.year = year
        this.quarter = quarter
        this.userId = userId

        const departmentListLength = searchStaffInfo.departmentNameList.length
        this.$set(this, 'userInfo', {
          name: searchStaffInfo.userName,
          position: searchStaffInfo.duty,
          department: searchStaffInfo.departmentNameList[departmentListLength - 1],
          avatar: searchStaffInfo.image,
        })

        // *viewmodel的数据结构定义
        // krData = {
        //   krDetail,
        //   krWeight,
        //   sevenTarget,
        //   tenTarget,
        // }
        // objectData = {
        //   objectDetail,
        //   objectWeight,
        //   weight,
        //   krDataList: [], // krData
        // }
        const objectDataList = []// objectData

        // *给objectList赋值
        objectList.forEach(objectItem => {
          const tmpKrs = []

          objectItem.keyResultList.forEach(krItem => {
            tmpKrs.push({
              krDetail: krItem.keyResultDetail || '-',
              krWeight: krItem.weight,
              tenTarget: krItem.tenTarget || '-',
              sevenTarget: krItem.sevenTarget || '-',
            })
          })

          objectDataList.push({
            objectDetail: objectItem.objectDetail || '-',
            objectWeight: objectItem.weight,
            krDataList: tmpKrs,
          })
        })
        this.$set(this, 'objectDataList', objectDataList)

        // *设置当前显示的object
        this.currentObject = objectDataList[0].krDataList
        // this.$set(this, 'currentObject', objectDataList[0])

        hide()
      } catch (error) {
        hide()
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    // key表示第几个o被选中，从1开始计数
    changeKrResult(key) {
      this.currentObject = this.objectDataList[key - 1].krDataList
    },
    // 点击返回该用户列表页
    handleList() {
      if (this.currentUser === this.userId) {
        this.$router.push({
          name: 'MyOKR',
        })
      } else {
        this.$router.push({
          name: 'OthersOKR',
          params: { userId: this.userId },
        })
      }
    },
  },
}
</script>

<style lang="less">
.m-detail{padding-bottom: 1.2rem;}
.m-infos{display: flex; flex-direction:row; align-items:center;  background-color: #fff; margin-bottom: 1px; padding: .2rem;
img{margin-right: .16rem;}
}
.m-infos-name{font-weight: bold; font-size: .14rem;}
.m-infos-posi{ font-size: .14rem; padding-left: .04rem;}
.m-infos-dep{ font-size: .11rem; color:#999;}
.ant-tabs-bar{background-color: #fff; margin-bottom: 0;}
.ant-tabs-nav-container{display: flex; justify-content: space-between; font-size:.16rem; font-weight: bold; color:#444;
.ant-tabs-tab-active,.ant-tabs-tab:hover{ color: #0064FA; font-weight: bold;}
}
.ant-tabs-ink-bar{background-color: #0064fa; height: .04rem;}
.m-o-box,.m-kr-outer{margin-top:.1rem; background-color: #fff;}
.m-o-box{ padding: .18rem .2rem;}
.m-o-weight{display:inline-block; background:#EAF4FF url('~@images/mIco-target.png') no-repeat left center; background-size: .16rem .16rem; padding:0 .04rem 0 .16rem; color:#0064FA; font-size:.11rem;}
.m-o-content{padding-top:.08rem; font-weight: bold; font-size: .16rem;}
.m-kr-weight{display:inline-block; background-color: #F0F2F5; padding: 0 .04rem;font-size:.11rem;}
.m-kr-content{padding-top:.08rem;  font-size: .14rem;}
.m-kr-box1{ padding: .1rem .2rem;}
.m-kr-box2{ padding: .12rem .2rem;}
.m-kr-box2{background-color: #FAFAFA; font-size: .14rem; color:#666;}
.m-kr-tag1,.m-kr-tag2{padding-left: .4rem;}
.m-kr-tag1{background:url('~@images/mIco-target1.png') no-repeat left .02rem; background-size: .32rem .16rem;}
.m-kr-tag2{background:url('~@images/mIco-target2.png') no-repeat left .02rem; background-size: .32rem .16rem;}
</style>
